/*
  This file is auto-generated. Do not edit it directly.
  To update this file, run `npm run codegen:common`.
*/

enum Feature {
  USER_HAS_MARKETPLACE_ACCESS = "USER_HAS_MARKETPLACE_ACCESS",
  USER_HAS_SERVICEDESK_ACCESS = "USER_HAS_SERVICEDESK_ACCESS",
  USER_HAS_VIEW_ACCESS_TO_ALL_PAGES = "USER_HAS_VIEW_ACCESS_TO_ALL_PAGES",
  VIEW_PARTNER_LIST = "VIEW_PARTNER_LIST",
  VIEW_PARTNER = "VIEW_PARTNER",
  CREATE_PARTNER = "CREATE_PARTNER",
  DELETE_PARTNER_UNPUBLISHED = "DELETE_PARTNER_UNPUBLISHED",
  VIEW_DELETE_PARTNER = "VIEW_DELETE_PARTNER",
  EDIT_PARTNER_CURRENCY = "EDIT_PARTNER_CURRENCY",
  EDIT_PARTNER_NAME_UNPUBLISHED = "EDIT_PARTNER_NAME_UNPUBLISHED",
  EDIT_PARTNER_NAME_PUBLISHED = "EDIT_PARTNER_NAME_PUBLISHED",
  EDIT_PARTNER_CONCESSION_OWNER_UNPUBLISHED = "EDIT_PARTNER_CONCESSION_OWNER_UNPUBLISHED",
  VIEW_PARTNER_CONCESSION_OWNER = "VIEW_PARTNER_CONCESSION_OWNER",
  EDIT_PARTNER_BUSINESS_REGION_UNPUBLISHED = "EDIT_PARTNER_BUSINESS_REGION_UNPUBLISHED",
  VIEW_PARTNER_BUSINESS_REGION = "VIEW_PARTNER_BUSINESS_REGION",
  EDIT_PARTNER_BUSINESS_DEV_MANAGER = "EDIT_PARTNER_BUSINESS_DEV_MANAGER",
  EDIT_PARTNER_DEFAULT_ACCESS = "EDIT_PARTNER_DEFAULT_ACCESS",
  EDIT_PARTNER_DEFAULT_CAPACITY = "EDIT_PARTNER_DEFAULT_CAPACITY",
  EDIT_PARTNER_MEANS_OF_TRANSPORT = "EDIT_PARTNER_MEANS_OF_TRANSPORT",
  EDIT_PARTNER_INTEGRATION_INTERMEDIARY = "EDIT_PARTNER_INTEGRATION_INTERMEDIARY",
  EDIT_PARTNER_CAPACITY_DECREASE_RULE = "EDIT_PARTNER_CAPACITY_DECREASE_RULE",
  EDIT_PARTNER_PASSENGER_BOOKING_DATA_ACCESS_ALLOWED = "EDIT_PARTNER_PASSENGER_BOOKING_DATA_ACCESS_ALLOWED",
  EDIT_PARTNER_PASSENGER_BOOKING_INFORMATION = "EDIT_PARTNER_PASSENGER_BOOKING_INFORMATION",
  VIEW_ALL_PARTNER_PASSENGER_BOOKING_INFORMATION_FIELDS = "VIEW_ALL_PARTNER_PASSENGER_BOOKING_INFORMATION_FIELDS",
  EDIT_PARTNER_BRAND = "EDIT_PARTNER_BRAND",
  VIEW_AVAILABLE_BRANDS = "VIEW_AVAILABLE_BRANDS",
  VIEW_PARTNER_BRAND_POLICIES = "VIEW_PARTNER_BRAND_POLICIES",
  EDIT_PARTNER_BRAND_POLICIES = "EDIT_PARTNER_BRAND_POLICIES",
  EDIT_PARTNER_SETTINGS = "EDIT_PARTNER_SETTINGS",
  EDIT_PARTNER_API_SETTINGS = "EDIT_PARTNER_API_SETTINGS",
  EDIT_PARTNER_INVENTORY_RULES = "EDIT_PARTNER_INVENTORY_RULES",
  EDIT_PARTNER_AUTO_ON_SALE_CONFIG = "EDIT_PARTNER_AUTO_ON_SALE_CONFIG",
  EDIT_PARTNER_IC_PRICING_RULES = "EDIT_PARTNER_IC_PRICING_RULES",
  VIEW_PARTNER_IC_PRICING_RULES = "VIEW_PARTNER_IC_PRICING_RULES",
  EDIT_PARTNER_TEAMS = "EDIT_PARTNER_TEAMS",
  EDIT_PARTNER_PUBLISH_POLICIES = "EDIT_PARTNER_PUBLISH_POLICIES",
  VIEW_PARTNER_TAGS = "VIEW_PARTNER_TAGS",
  EDIT_PARTNER_TAGS = "EDIT_PARTNER_TAGS",
  VIEW_PARTNER_USERS = "VIEW_PARTNER_USERS",
  VIEW_PARTNER_TEST_USERS = "VIEW_PARTNER_TEST_USERS",
  VIEW_LINE = "VIEW_LINE",
  CREATE_LINE = "CREATE_LINE",
  EDIT_LINE_DESCRIPTION_UNPUBLISHED = "EDIT_LINE_DESCRIPTION_UNPUBLISHED",
  EDIT_LINE_CODE_UNPUBLISHED = "EDIT_LINE_CODE_UNPUBLISHED",
  EDIT_LINE_CONTRACT_MODEL_UNPUBLISHED = "EDIT_LINE_CONTRACT_MODEL_UNPUBLISHED",
  EDIT_LINE_BRAND = "EDIT_LINE_BRAND",
  EDIT_LINE_CUT_OFF_SALES = "EDIT_LINE_CUT_OFF_SALES",
  EDIT_LINE_AMENITIES = "EDIT_LINE_AMENITIES",
  EDIT_LINE_MINIMUM_SEAT_CAPACITY = "EDIT_LINE_MINIMUM_SEAT_CAPACITY",
  EDIT_LINE_DEFAULT_CIRCULATION = "EDIT_LINE_DEFAULT_CIRCULATION",
  EDIT_LINE_MEANS_OF_TRANSPORT_UNPUBLISHED = "EDIT_LINE_MEANS_OF_TRANSPORT_UNPUBLISHED",
  EDIT_LINE_FORBIDDEN_RELATIONS_ADD = "EDIT_LINE_FORBIDDEN_RELATIONS_ADD",
  EDIT_LINE_FORBIDDEN_RELATIONS_DELETE = "EDIT_LINE_FORBIDDEN_RELATIONS_DELETE",
  DELETE_LINE_UNPUBLISHED = "DELETE_LINE_UNPUBLISHED",
  UPLOAD_FORBIDDEN_RELATIONS = "UPLOAD_FORBIDDEN_RELATIONS",
  CREATE_SCHEDULE = "CREATE_SCHEDULE",
  VIEW_SCHEDULE = "VIEW_SCHEDULE",
  VIEW_SCHEDULE_VALIDATION = "VIEW_SCHEDULE_VALIDATION",
  CREATE_SCHEDULE_COPY = "CREATE_SCHEDULE_COPY",
  CREATE_SCHEDULE_CONCEPT_CHANGE = "CREATE_SCHEDULE_CONCEPT_CHANGE",
  DELETE_SCHEDULE = "DELETE_SCHEDULE",
  EDIT_SCHEDULE_NAME_UNPUBLISHED = "EDIT_SCHEDULE_NAME_UNPUBLISHED",
  EDIT_SCHEDULE_PERIOD_UNPUBLISHED = "EDIT_SCHEDULE_PERIOD_UNPUBLISHED",
  EDIT_SCHEDULE_INITIAL_CAPACITY_UNPUBLISHED = "EDIT_SCHEDULE_INITIAL_CAPACITY_UNPUBLISHED",
  EDIT_SCHEDULE_NON_OPERATIONAL_PERIOD_UNPUBLISHED = "EDIT_SCHEDULE_NON_OPERATIONAL_PERIOD_UNPUBLISHED",
  EDIT_SCHEDULE_TIMETABLE_UNPUBLISHED = "EDIT_SCHEDULE_TIMETABLE_UNPUBLISHED",
  EDIT_SCHEDULE_SUBMIT_TO_REVIEW = "EDIT_SCHEDULE_SUBMIT_TO_REVIEW",
  EDIT_SCHEDULE_APPROVE_REJECT = "EDIT_SCHEDULE_APPROVE_REJECT",
  EDIT_SCHEDULE_PUBLISH = "EDIT_SCHEDULE_PUBLISH",
  EDIT_SCHEDULE_ACTIVATE_ON_SALE = "EDIT_SCHEDULE_ACTIVATE_ON_SALE",
  EDIT_SCHEDULE_ARCHIVE = "EDIT_SCHEDULE_ARCHIVE",
  EDIT_SCHEDULE_PUT_ON_HIDDEN = "EDIT_SCHEDULE_PUT_ON_HIDDEN",
  VIEW_SCHEDULE_STATUS_HISTORY = "VIEW_SCHEDULE_STATUS_HISTORY",
  EDIT_SCHEDULE_STATUS = "EDIT_SCHEDULE_STATUS",
  VIEW_SCHEDULE_DETAILED_STATUS = "VIEW_SCHEDULE_DETAILED_STATUS",
  VIEW_HIDDEN_STATUS = "VIEW_HIDDEN_STATUS",
  EDIT_PRICING = "EDIT_PRICING",
  VIEW_ALL_OPS_PARTNER = "VIEW_ALL_OPS_PARTNER",
  VIEW_RIDES = "VIEW_RIDES",
  EDIT_CAPACITY_MANAGER_CAPACITY = "EDIT_CAPACITY_MANAGER_CAPACITY",
  EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES = "EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES",
  EDIT_CAPACITY_MANAGER_CANCEL_RIDE = "EDIT_CAPACITY_MANAGER_CANCEL_RIDE",
  VIEW_CAPACITY_MANAGER_RIDES_IN_PREVIEW = "VIEW_CAPACITY_MANAGER_RIDES_IN_PREVIEW",
  VIEW_BOOKINGS = "VIEW_BOOKINGS",
  VIEW_BOOKING_REPORTS_DOWNLOAD = "VIEW_BOOKING_REPORTS_DOWNLOAD",
  CREATE_STATION = "CREATE_STATION",
  VIEW_STATIONS = "VIEW_STATIONS",
  CREATE_CITY = "CREATE_CITY",
  VIEW_CITIES = "VIEW_CITIES",
  CREATE_STATION_IMPORT = "CREATE_STATION_IMPORT",
  CREATE_CITY_IMPORT = "CREATE_CITY_IMPORT",
  EDIT_STATION_INREVIEW = "EDIT_STATION_INREVIEW",
  EDIT_STATION_APPROVED = "EDIT_STATION_APPROVED",
  EDIT_STATION_PUBLISHED = "EDIT_STATION_PUBLISHED",
  EDIT_STATION_REJECTED = "EDIT_STATION_REJECTED",
  EDIT_STATION_APPROVE_REJECT = "EDIT_STATION_APPROVE_REJECT",
  EDIT_CITY_STATION_APPROVER = "EDIT_CITY_STATION_APPROVER",
  VIEW_POWER_BI_REPORT = "VIEW_POWER_BI_REPORT",
  VIEW_PAX_LIST = "VIEW_PAX_LIST",
  CHECK_IN_MANUAL = "CHECK_IN_MANUAL",
  CHECK_IN_QR = "CHECK_IN_QR",
  CHANGE_PARTNER = "CHANGE_PARTNER",
  USER_HAS_MUS_ACCESS = "USER_HAS_MUS_ACCESS",
}

export default Feature;
